import React, { useEffect, useState } from "react";
import { Container, Button } from "react-bootstrap";

function Smart() {
    const [theme, setTheme] = useState("light");
    const [mouseX, setMouseX] = useState(0);
    const [mouseY, setMouseY] = useState(0);
  
    const toggleTheme = () => {
      setTheme(theme === "light" ? "dark" : "light");
    };
  
    useEffect(() => {
      const handleMouseMove = (event) => {
        setMouseX(event.clientX);
        setMouseY(event.clientY);
      };
  
      window.addEventListener("mousemove", handleMouseMove);
      return () => window.removeEventListener("mousemove", handleMouseMove);
    }, []);
  return (
    <main className={`error-page ${theme}`}>
    <Container className="error-page__container mt-5">
      <div className="eyes">
        <div className="eye">
          <div
            className="eye__pupil eye__pupil--left"
            style={{ transform: `translate(${mouseX / 50}px, ${mouseY / 50}px)` }}
          ></div>
        </div>
        <div className="eye">
          <div
            className="eye__pupil eye__pupil--right"
            style={{ transform: `translate(${mouseX / 50}px, ${mouseY / 50}px)` }}
          ></div>
        </div>
      </div>
      <div className="error-page__heading">
        <h1 className="error-page__heading-title">Products Not Found!</h1>
        <p className="error-page__heading-description">404 error</p>
      </div>
      <Button className="error-page__button" href="/">
        Back to Home
      </Button>
    </Container>
    <button className="color-switcher" onClick={toggleTheme} color="#005b96">
      {theme === "light" ? "🌙" : "☀️"}
    </button>
  </main>
  )
}

export default Smart